<template>
  <div class="main">
    <c-panel>
      <form-categoria :paramId="$route.params.id" v-on:onSubmitCategoria="onSubmitCategoria"></form-categoria>
    </c-panel>
  </div>
</template>
<script>
import formCategoria from "./form"

export default {
  methods: {
    onSubmitCategoria () {
      this.$router.push('/admin/merenda/categoria')
    }
  },
  components: { formCategoria }
}
</script>
